import { ITEMS_PER_PAGE } from '@mais-retorno-front/constants/items-per-page';
import { getW3CDatefromDate } from '@mais-retorno-front/helpers/format';
import { getVideoThumbFromYoutube } from '@mais-retorno-front/helpers/video-thumb';
import { ISitemap } from '@mais-retorno-front/models/sitemaps.model';
import { AxiosInstance } from 'axios';

interface IResponse {
  data: {
    videos: {
      data: {
        attributes: {
          title: string;
          slug: string;
          path: string;
          video_id: string;
          publishedAt: string;
          SEO: {
            description: string;
          };
        };
      }[];
    };
  };
}

export class GetVideosSitemapUseCase {
  constructor(private readonly http: AxiosInstance) {}

  async execute(page: number): Promise<ISitemap[]> {
    const { data } = await this.http.post<IResponse>('', {
      query: `
        query videos {
          videos(pagination: { page: ${page}, pageSize: ${ITEMS_PER_PAGE.sitemaps} }) {
            data {
              attributes {
                title
                slug
				        path
                video_id
                publishedAt
                SEO {
                  description
                }
              }
            }
          }
        }
      `,
    });

    const videos = data?.data?.videos?.data;

    if (!videos || videos.length === 0) {
      return [];
    }

    return videos.map((video) => {
      return {
        url: `${process.env.NEXT_PUBLIC_DOMAIN}${video.attributes?.path}/${video.attributes?.slug}`,
        video: {
          thumbnail_url:
            getVideoThumbFromYoutube(video.attributes?.video_id) || '/img/placeholder.png',
          player_url: `https://www.youtube.com/embed/${video.attributes?.video_id}`,
          title: video.attributes?.title || null,
          description: video.attributes?.SEO?.description || null,
          publishedAt: `${getW3CDatefromDate(
            video.attributes?.publishedAt
          )}-03:00`,
          family_friendly: 'yes',
          requires_subscription: 'no',
        },
      };
    });
  }
}
